import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import { PMDialog } from "../../utils/PMDialog";
import { ProjectActivitySelector } from "../../utils/moduleSelectors/projectActivitySelector";
import { planGhostBtnClass, planPrimaryBtnClass } from "./projectPlanTheme";

/**
 * Step 1 for «Planlegg aktivitet»: pick a project activity, then open PlanScheduleModal.
 */
export function PlanActivityPickerDialog({ open, onClose, project, onContinue }) {
  const { t } = useTranslation();
  const [activity, setActivity] = useState(null);

  useEffect(() => {
    if (!open) {
      setActivity(null);
    }
  }, [open]);

  const handleContinue = () => {
    if (!activity?.id) {
      toast.error(t("project.plan.schedule_activity.pick_required"));
      return;
    }
    onContinue?.(activity);
    onClose?.();
  };

  return (
    <PMDialog
      open={open}
      onClose={onClose}
      title={t("project.plan.schedule_activity.pick_title")}
      size="md"
    >
      <p className="mb-4 text-sm text-[#6B7682]">
        {t("project.plan.schedule_activity.pick_help")}
      </p>

      <ProjectActivitySelector
        project={project}
        selected={activity}
        onChange={(e) => setActivity(e.target?.object || null)}
        label={t("project_activity.label")}
        noneLabelKey="project_activity.none"
        disabled={!project?.id}
      />

      {!project?.id ? (
        <p className="mt-2 text-xs text-amber-700">{t("project.plan.select_project_first")}</p>
      ) : null}

      <div className="mt-6 flex flex-wrap justify-end gap-2">
        <button type="button" onClick={onClose} className={planGhostBtnClass}>
          {t("Cancel")}
        </button>
        <button
          type="button"
          onClick={handleContinue}
          disabled={!activity?.id}
          className={planPrimaryBtnClass}
        >
          {t("project.plan.schedule_activity.continue")}
        </button>
      </div>
    </PMDialog>
  );
}
